import React from 'react'
import FontAwesome from 'react-fontawesome'
import Modal from '../../modal/modal.component.jsx'
import StyledChangeAddressModalBody from '../address-manager/styles/styled-change-address-modal-body.style'
import Address from './address.component.jsx'
import { AddressService } from './../../../services/address.service'

class ChangeAddressModal extends React.Component {
	constructor(props) {
		super(props)
		this.removeAddress = removeAddress.bind(this)
		this.setBillingAddress = setBillingAddress.bind(this)
		this.closeAndOpenEditModal = closeAndOpenEditModal.bind(this)
	}

	render() {
		const { isOpen, onClose, addresses } = this.props

		return (
			<Modal
				onClose={onClose}
				ref="changeAddressModal"
				isOpen={isOpen}
				large>
				<StyledChangeAddressModalBody>
					<div className="orange semi-bold f30">Alterar endereço</div>
					<p>Clique no endereço para selecioná-lo</p>
					<div className="addresses">
						<div
							className="add-address"
							onClick={this.closeAndOpenEditModal(null)}>
							<FontAwesome name="plus" size="2x" />
							<span className="blue">Adicionar endereço</span>
						</div>
						{addresses.map((address, index) => (
							<Address
								key={index}
								address={address}
								onRemove={this.removeAddress(index)}
								onSelect={this.setBillingAddress(index)}
								onEdit={this.closeAndOpenEditModal(index)}
							/>
						))}
					</div>
				</StyledChangeAddressModalBody>
			</Modal>
		)
	}
}

function removeAddress(index) {
	return () => {
		const { id } = this.props.addresses[index]
		AddressService.inactivateAddress(null, id).then(({ success }) => {
			if (success) this.props.onRemove(id)
		})
	}
}

function setBillingAddress(index) {
	return () => this.props.onChange(index)
}

function closeAndOpenEditModal(index) {
	return () => this.props.onEdit(index)
}

export default ChangeAddressModal
